import React, { Fragment, useEffect, useState } from 'react';
import { IMAGES } from '../../../constants';
import { useDispatch, useSelector } from 'react-redux';
import { getChatUserAction } from '../../../actions/chatAction';
import { getMessageHistoryAction } from '../../../actions/chatAction';
import Avatar from 'react-avatar';
import { FormattedMessage } from 'react-intl';
import { socket } from '../../../utils/socket';
import $ from 'jquery';
import { getParamsByName, encryptData, decryptData } from '../../../helper';
import { CHAT_ACTIVE_STATUS_SUCCESS } from '../../../constants/chatConstant';
import Loader from '../../layout/Loader';





const Users = () => {
    var url_seller_id = getParamsByName(window.location.href, 'chat')
    url_seller_id = url_seller_id ? url_seller_id : 0;

    if (socket?.connected === false || !socket) {
        window.location.reload()
        socket.connected = true;
        // socket.disconnected = false;
    }
    const dispatch = useDispatch();

    const [active, setActive] = useState();
    var { chatuser, loading } = useSelector(state => state.chatuser);
    const [pageloading, setPageloading] = useState(false)
    const user_id = sessionStorage.getItem('user') && JSON.parse(sessionStorage.getItem('user')).id;
    const messageHistory = useSelector(state => state.messageHistory);
    const [userData , setUserData] = useState([]);



    useEffect(async () => {
        if ((!chatuser || chatuser == null) && (!sessionStorage.getItem('loading'))) {
            sessionStorage.removeItem('other_user_id')
            // setPageloading(true)
            setTimeout(() => {
                sessionStorage.setItem('loading', true)
                dispatch(getChatUserAction());
                // setPageloading(false)
            }, 2500);
        }
        setTimeout(() => {
            $('.ul_' + url_seller_id).trigger('click');
        }, 200);
    }, [dispatch, chatuser, sessionStorage.getItem('loading')])

    useEffect(() => {
        if (socket?.connected) {
            dispatch(getChatUserAction());
        }
    }, [])

    const handleClickUser = (other_user_id, other_user_name, other_profile_picture_full_thumb, group_id) => {
        if (active != other_user_id) {
            // dispatch({ GET_MESSAGE_HISTORY_FAIL: null })
            // dispatch(getMessageHistoryAction('RESET'))
            setActive(other_user_id);
            dispatch({
                type: CHAT_ACTIVE_STATUS_SUCCESS,
                payload: other_user_id
            })
            console.log(other_user_id, other_user_name, other_profile_picture_full_thumb, group_id)
            sessionStorage.setItem('other_user_id', other_user_id)
            sessionStorage.setItem('socket_group_id', group_id);
            sessionStorage.setItem('other_user_name', other_user_name ? other_user_name : 'Cevaheer')
            sessionStorage.setItem('other_profile_picture_full_thumb', other_profile_picture_full_thumb)
            sessionStorage.setItem('newChat', 0)
            // console.log(user_id, other_user_id, 1, 10)
            dispatch(getMessageHistoryAction(user_id, other_user_id, 1, 20))
        
            socket?.emit('total_message_count', {});
            var read = { other_user_id: other_user_id, ids: [], type: "msg_read" };
            // socket?.emit('read_message', encryptData(read));
            socket?.emit('read_message', read);
            $('.ul_' + other_user_id + ' li .total_unseen').hide();
        }
    }

    useEffect(() => {
        sessionStorage.removeItem('loading')
    }, [])

    useEffect(()=>{
      if(chatuser && chatuser.length > 0){
        setUserData(chatuser)
      }  
    },[chatuser])


    return (
        <Fragment>
            {pageloading && (!sessionStorage.getItem('loading')) ? <Loader /> : ""}
            <div className="col-md-5 col-lg-3 lefts pl-5">
                {/* <h2 className="mt-4 mb-3"><FormattedMessage id="Messages" defaultMessage="Messages" /></h2> */}
                <div
                    className='chat-sidebar'
                    style={{
                        overflowY: "auto",
                        paddingRight: "10px"

                    }}
                >
                    {
                        chatuser?.length ? chatuser?.map((user, i) => {
                            let l_id = user.user_id == user_id ? user.other_user_id : user.user_id;
                            let l_name = user.user_id == user_id ? user.company_name : user.other_company_name;
                            let group_id = user.group_id == user_id ? user.group_id : user.group_id;

                            // let l_profile_picture_full_thumb = user.user_id == user_id?user.profile_picture:user.other_profile_pic;
                            let l_profile_picture_full_thumb = user?.user_id == -1 ? IMAGES?.CHAT_LOGO : (user?.user_id == user_id ? user?.profile_picture : user?.other_profile_pic);

                            return (
                                <ul key={i} className={"mesList chat-list ul_" + l_id} onClick={() => handleClickUser(l_id, l_name, l_profile_picture_full_thumb, group_id)}>
                                    <li className={active === l_id ? 'active' : null} >
                                        {/* <img src={IMAGES.IMAGE_01} className="avtar_img" /> */}
                                        <Avatar
                                            name={user.name}
                                            className={l_profile_picture_full_thumb ? "avtar_img" : "avtar_img chatImageSide"}
                                            color="#012F5B"
                                            size="45"
                                            value="86%"
                                            src={l_profile_picture_full_thumb ? l_profile_picture_full_thumb : IMAGES?.PROFILE5}
                                            round />
                                        <h4>{l_name ? l_name : 'Cevaheer'}</h4>
                                        {/* <span>Awesome! Have a go..</span> */}
                                        {user.total_unseen > 0 ? <span className="float-right total_unseen">{user.total_unseen}</span> : ''}

                                    </li>
                                </ul>
                            )
                        })
                        :<p>No Messages Found</p>
                    }
                </div>
            </div>
        </Fragment>
    )
}

export default Users
